import { Info, Loader, X } from 'lucide-react';
import React, { useEffect, useRef, useState} from 'react';
import Spacing from '../Spacing';
import { exchangeDate, Gender, notify, usPhoneFormat } from "../../helpers";
import { fetchSingleReferralData, updateRefrerralInfo } from '../../services/easyReferral';
import { Config } from '../../Config';
import { Drawer } from 'vaul';

export default function ReferralDetailsViewModal(props) {
  const {
    filter = {},
    setDataLoading = () => {},
    dataLoad = () => {},
    viewReferral = {},
    setViewReferral = () => {},
    viewReferralId = "",
    account_id = "",
    location_id = "",
    specialty_id = "",
    setViewImage = () => {},
    setOpenImageViewModal = () => {},
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
  } = props;

  const [updateLoader, setUpdateLoader] = useState(false);
  const [viewReferralData, setViewReferralData] = useState({});
  const [selectNoteFiles, setSelectNoteFiles] = useState([]);
  const [selectLabFiles, setSelectLabFiles] = useState([]);
  const defaultEditData = {
    account_id: account_id,
    location_id: location_id,
    specialty_id: specialty_id,
    referral_id: viewReferralId,
    refer_consult_note_files: [],
    refer_lab_document_files: [],
    status: '',
  }
  const [referPatientData, setReferPatientData] = useState(defaultEditData);
  const dropdownRef = useRef(null);

  const loadData = async (accountId, locationId, referralId) => {
    const response = await fetchSingleReferralData(
      accountId,
      locationId,
      referralId
    );
    if (response) {
      setViewReferralData(response?.data);
      setReferPatientData({
        ...referPatientData,
        status: response?.data?.referral_info?.status
      });
    }
  };

  useEffect(() => {
    loadData(account_id, location_id, viewReferralId);
  }, [account_id, location_id, viewReferralId]);

  const handleNoteFileChange = (event) => {
    const files = Array.from(event.target.files);
    const acceptFileSize = Config?.uploadFileSizeLimit * 1024 * 1024;

    const validFiles = files.filter((file) => file.size <= acceptFileSize);
    const invalidFiles = files.filter((file) => file.size > acceptFileSize);

    if (invalidFiles.length > 0) {
      notify("error", `Exceed the size limit of ${Config?.uploadFileSizeLimit}MB`);
    }
    const updatedFiles = [...selectNoteFiles, ...validFiles];
    setSelectNoteFiles(updatedFiles);

    setReferPatientData({
      ...referPatientData,
      refer_consult_note_files: updatedFiles,
    });
  };

  const removeNoteFile = (index) => {
    const newFiles = selectNoteFiles.filter((_, i) => i !== index);
    setSelectNoteFiles(newFiles);

    setReferPatientData({
      ...referPatientData,
      refer_consult_note_files: newFiles,
    });
  };

  const handleLabFileChange = (event) => {
    const files = Array.from(event.target.files);
    const acceptFileSize = Config?.uploadFileSizeLimit * 1024 * 1024;

    const validFiles = files.filter((file) => file.size <= acceptFileSize);
    const invalidFiles = files.filter((file) => file.size > acceptFileSize);

    if (invalidFiles.length > 0) {
      notify("error", `Exceed the size limit of ${Config?.uploadFileSizeLimit}MB`);
    }
    const updatedFiles = [...selectLabFiles, ...validFiles];
    setSelectLabFiles(updatedFiles);

    setReferPatientData({
      ...referPatientData,
      refer_lab_document_files: updatedFiles,
    });
  };

  const removeLabFile = (index) => {
    const newFiles = selectLabFiles.filter((_, i) => i !== index);
    setSelectLabFiles(newFiles);

    setReferPatientData({
      ...referPatientData,
      refer_lab_document_files: newFiles,
    });
  };

  const handleReferralChange = (e) => {
    const { name, value } = e.target;
    setReferPatientData({
      ...referPatientData,
      [name]: value
    });
  };

  const handleReferUpdate = async (e) => {
    e.preventDefault();
    setUpdateLoader(true);
    e.target.disabled = true;

    try {
      const response = await updateRefrerralInfo(referPatientData);
      if(response){
        if(response?.detail) {
          notify("error", response?.detail);
        } else {
          setDataLoading(true);
          dataLoad(filter);
          setReferPatientData(defaultEditData);
          setSelectNoteFiles([]);
          setSelectNoteFiles([]);
          handleDrawerClose();
          notify("success", response?.data?.message);
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    } finally {
      setUpdateLoader(false);
    }

    e.target.disabled = false;
  };
   
  const handleDrawerClose = () => {
    setViewReferral(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={viewReferral} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Send Letter</Drawer.Title>
            <Drawer.Description className="sr-only">Send letter of a parient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">
              <div className="docpro_modal">
                {viewReferralData?.length === 0 ? (
                  <div
                    style={{
                      height: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Loading...
                  </div>
                ) : (
                  <div style={{ backgroundColor: '#FFFFFF' }}>
                    <h2 className="docpro_fs_24" style={{ textAlign: 'center' }}>Referral Patient View</h2>

                    <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                      <div className="docpro_grid_item w-full">
                        <h6>Patient Information</h6>
                        <table className="docpro_referral_table">
                          <tbody>
                            <tr>
                              <td className='docpro_indigo_color' style={{ width: '115px' }}>First Name</td>
                              <td style={{ width: '15px' }}>:</td>
                              <td>{viewReferralData?.patient_info?.first_name}</td>
                            </tr>
                            <tr>
                              <td className='docpro_indigo_color'>Last Name</td>
                              <td>:</td>
                              <td>{viewReferralData?.patient_info?.last_name}</td>
                            </tr>
                            <tr>
                              <td className='docpro_indigo_color'>Gender</td>
                              <td>:</td>
                              <td>{Gender(viewReferralData?.patient_info?.sex)}</td>
                            </tr>
                            <tr>
                              <td className='docpro_indigo_color'>Date of Birth</td>
                              <td>:</td>
                              <td>{exchangeDate(viewReferralData?.patient_info?.dob)}</td>
                            </tr>
                            <tr>
                              <td className='docpro_indigo_color'>Phone</td>
                              <td>:</td>
                              <td>{viewReferralData?.patient_info?.mobile_phone ? usPhoneFormat(viewReferralData?.patient_info?.mobile_phone) : usPhoneFormat(viewReferralData?.patient_info?.home_phone)}</td>
                            </tr>
                            <tr>
                              <td className='docpro_indigo_color'>Insurance</td>
                              <td>:</td>
                              <td>{viewReferralData?.patient_info?.insurance?.name}</td>
                            </tr>
                            <tr>
                              <td className='docpro_indigo_color'>Insurance ID</td>
                              <td>:</td>
                              <td>{viewReferralData?.patient_info?.insurance_code}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div className="docpro_grid_item w-full">
                        <h6>Referral Information</h6>
                        <table className="docpro_referral_table">
                          <tbody>
                            {filter?.refer_type === 'incoming' ? (
                              <tr>
                                <td className='docpro_indigo_color' style={{ width: '120px' }}>Referred From</td>
                                <td style={{ width: '15px' }}>:</td>
                                <td><b className='docpro_green_color'>{viewReferralData?.provider_info?.from?.provider_organization_name}</b></td>
                              </tr>
                            ) : (
                              <tr>
                                <td className='docpro_indigo_color' style={{ width: '120px' }}>Referred To</td>
                                <td style={{ width: '15px' }}>:</td>
                                <td><b className='docpro_green_color'>{viewReferralData?.provider_info?.to?.provider_organization_name}</b></td>
                              </tr>
                            )}
                            <tr>
                              <td className='docpro_indigo_color'>Priority</td>
                              <td>:</td>
                              <td>{viewReferralData?.referral_info?.patient_conditon}</td>
                            </tr>
                            <tr>
                              <td className='docpro_indigo_color'>Referral Date</td>
                              <td>:</td>
                              <td>{exchangeDate(viewReferralData?.referral_info?.refer_date)}</td>
                            </tr>
                            <tr>
                              <td className='docpro_indigo_color'>End Date</td>
                              <td>:</td>
                              <td>{exchangeDate(viewReferralData?.referral_info?.refer_end_date)}</td>
                            </tr>
                            <tr>
                              <td className='docpro_indigo_color'>Auth Code</td>
                              <td>:</td>
                              <td>{viewReferralData?.referral_info?.refer_auth_code}</td>
                            </tr>
                            <tr>
                              <td className='docpro_indigo_color'>Referral Status</td>
                              <td>:</td>
                              <td>
                                {viewReferralData?.referral_info?.status === 'Pending' ?
                                  <span className='docpro_orange_color'>{viewReferralData?.referral_info?.status}</span>
                                :
                                viewReferralData?.referral_info?.status === 'Completed' ?
                                  <span className='docpro_green_color'>{viewReferralData?.referral_info?.status}</span>
                                :
                                viewReferralData?.referral_info?.status === 'Confirm' ?
                                  <span className='docpro_indigo_color'>{viewReferralData?.referral_info?.status}</span>
                                :
                                  ""
                                }
                              </td>
                            </tr>
                            <tr>
                              <td className='docpro_indigo_color'>DOS</td>
                              <td>:</td>
                              <td>{exchangeDate(viewReferralData?.referral_info?.dos)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <h6 style={{ textAlign: 'center' }}>Additional Information</h6>
                    <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                      <div className="docpro_grid_item w-full">
                        <p className='docpro_mb_0'><b className='docpro_indigo_color'>Referral Reason :</b></p>
                        <p className='docpro_mb_0 docpro_ref_details_description'>
                          {viewReferralData?.referral_info?.refer_reason}
                        </p>
                      </div>
                      <div className="docpro_grid_item w-full">
                        <p className='docpro_mb_0'><b className='docpro_indigo_color'>Attach Medical Summary :</b></p>
                        <ul className="docpro_mb_0 docpro_ref_details_description" style={{ listStyle: 'none' }}>
                          {viewReferralData?.referral_info?.attach_medical_summary_files?.map((element, index) => {
                            const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(element?.file_name);

                            return (
                              <li key={index} className='docpro_green_color'>
                                {element?.status === "success" ? (
                                  isImage ? (
                                    <div
                                      className='pointer'
                                      onClick={() => {
                                        setViewImage(`${Config?.FileUploadPortal}${element?.file_path}`);
                                        setOpenImageViewModal(true);
                                        setPreviousScrollPosition(window.scrollY);
                                        window.scrollTo(0, 0);
                                      }}
                                    >
                                      {element?.file_name}
                                    </div>
                                  ) : (
                                    <a href={`${Config?.FileUploadPortal}${element?.file_path}`} target="_blank" rel="noopener noreferrer">
                                      {element?.file_name}
                                    </a>
                                  )
                                ) : (
                                  <span title={`${element?.message}`}>{element?.file_name}</span>
                                )}
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    </div>

                    <Spacing lg="20" sm="20" />

                    <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                      <div className="docpro_grid_item w-full">
                        <p className='docpro_mb_0'><b className='docpro_indigo_color'>Active Medication List :</b></p>
                        <p className='docpro_mb_0 docpro_ref_details_description'>
                          {viewReferralData?.referral_info?.active_medication_list}
                        </p>
                      </div>

                      <div className="docpro_grid_item w-full">
                        <p className='docpro_mb_0'><b className='docpro_indigo_color'>Diagnosis :</b></p>
                        <p className='docpro_mb_0 docpro_ref_details_description'>
                          {viewReferralData?.referral_info?.diagnosis}
                        </p>
                      </div>
                    </div>

                    <Spacing lg="30" sm="30" />

                    <h6 style={{ textAlign: 'center' }}>Reports</h6>
                    <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                      <div className="docpro_grid_item w-full">
                        <p className='docpro_mb_0'><b className='docpro_indigo_color'>Consult Note :</b></p>
                        <ul className="docpro_mb_0 docpro_ref_details_description" style={{ listStyle: 'none' }}>
                          {viewReferralData?.referral_info?.refer_consult_note_files?.map((element, index) => {
                            const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(element?.file_name);

                            return (
                              <li key={index} className='docpro_green_color'>
                                {element?.status === "success" ? (
                                  isImage ? (
                                    <div
                                      className='pointer'
                                      onClick={() => {
                                        setViewImage(`${Config?.FileUploadPortal}${element?.file_path}`);
                                        setOpenImageViewModal(true);
                                        setPreviousScrollPosition(window.scrollY);
                                        window.scrollTo(0, 0);
                                      }}
                                    >
                                      {element?.file_name}
                                    </div>
                                  ) : (
                                    <a href={`${Config?.FileUploadPortal}${element?.file_path}`} target="_blank" rel="noopener noreferrer">
                                      {element?.file_name}
                                    </a>
                                  )
                                ) : (
                                  <span title={`${element?.message}`}>{element?.file_name}</span>
                                )}
                              </li>
                            )
                          })}
                        </ul>
                      </div>

                      <div className="docpro_grid_item w-full">
                        <p className='docpro_mb_0'><b className='docpro_indigo_color'>Lab Document :</b></p>
                        <ul className="docpro_mb_0 docpro_ref_details_description" style={{ listStyle: 'none' }}>
                          {viewReferralData?.referral_info?.refer_lab_document_files?.map((element, index) => {
                            const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(element?.file_name);

                            return (
                              <li key={index} className='docpro_green_color'>
                                {element?.status === "success" ? (
                                  isImage ? (
                                    <div
                                      className='pointer'
                                      onClick={() => {
                                        setViewImage(`${Config?.FileUploadPortal}${element?.file_path}`);
                                        setOpenImageViewModal(true);
                                        setPreviousScrollPosition(window.scrollY);
                                        window.scrollTo(0, 0);
                                      }}
                                    >
                                      {element?.file_name}
                                    </div>
                                  ) : (
                                    <a href={`${Config?.FileUploadPortal}${element?.file_path}`} target="_blank" rel="noopener noreferrer">
                                      {element?.file_name}
                                    </a>
                                  )
                                ) : (
                                  <span title={`${element?.message}`}>{element?.file_name}</span>
                                )}
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    </div>

                    {(filter?.refer_type === 'incoming' && viewReferralData?.referral_info?.status !== "Completed") &&
                      <form onSubmit={handleReferUpdate}>
                        <Spacing lg="30" sm="30" />

                        <h6 style={{ textAlign: 'center' }}>Send Reports</h6>
                        <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                          <div className="docpro_grid_item w-full">
                            <label className="docpro_fw_500 docpro_primary_color">
                              Consult Notes
                              <button type='button' className="docpro_icon_btn overview pl-2" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
                                <Info width={15} height={15} />
                                <div className="docpro_tip">
                                  <span>Max file size {Config?.uploadFileSizeLimit}MB <br /> Accepted file types <br /> {Config?.acceptUploadFileType}</span>
                                </div>
                              </button>
                            </label>
                            <div className='input_file_conatiner'>
                              <label htmlFor="note-file-upload" className='file_button'>
                                Choose Files
                              </label>
                              <input
                                type="file"
                                id="note-file-upload"
                                name="refer_consult_note_files[]"
                                multiple
                                accept={Config?.acceptUploadFileType}
                                className='file_hidden_input'
                                onChange={handleNoteFileChange}
                              />
                              <span className='file_label'>{selectNoteFiles?.length === 1 ? `${selectNoteFiles?.length} File` : selectNoteFiles?.length > 1 ? `${selectNoteFiles?.length} Files` : 'No file chosen'}</span>
                            </div>

                            <ul className="mt-1 docpro_mb_0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                              {selectNoteFiles.map((file, index) => (
                                <li key={index}>
                                  <span onClick={() => removeNoteFile(index)} className="docpro_red_color px-1 py-1" style={{ cursor: 'pointer' }}><X height={15} width={15} /></span>
                                  <span className="pl-2">{file.name}</span>
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="docpro_grid_item w-full">
                            <label className="docpro_fw_500 docpro_primary_color">
                              Chart/Lab Document
                              <button type='button' className="docpro_icon_btn overview pl-2" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
                                <Info width={15} height={15} />
                                <div className="docpro_tip">
                                  <span>Max file size {Config?.uploadFileSizeLimit}MB <br /> Accepted file types <br /> {Config?.acceptUploadFileType}</span>
                                </div>
                              </button>
                            </label>
                            <div className='input_file_conatiner'>
                              <label htmlFor="lab-file-upload" className='file_button'>
                                Choose Files
                              </label>
                              <input
                                type="file"
                                id="lab-file-upload"
                                name="refer_lab_document_files[]"
                                multiple
                                accept={Config?.acceptUploadFileType}
                                className='file_hidden_input'
                                onChange={handleLabFileChange}
                              />
                              <span className='file_label'>{selectLabFiles?.length === 1 ? `${selectLabFiles?.length} File` : selectLabFiles?.length > 1 ? `${selectLabFiles?.length} Files` : 'No file chosen'}</span>
                            </div>

                            <ul className="mt-1 docpro_mb_0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                              {selectLabFiles.map((file, index) => (
                                <li key={index}>
                                  <span onClick={() => removeLabFile(index)} className="docpro_red_color px-1 py-1" style={{ cursor: 'pointer' }}><X height={15} width={15} /></span>
                                  <span className="pl-2">{file.name}</span>
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="docpro_grid_item w-full">
                            <label className="docpro_fw_500 docpro_primary_color">
                              Referred Status <span className="docpro_red_color">*</span>
                            </label>
                            <select className="docpro_form_field size_lg" name='status' required value={referPatientData?.status} onChange={handleReferralChange}>
                              <option value="Pending">Pending</option>
                              <option value="Confirm">Confirm</option>
                              <option value="Completed">Completed</option>
                            </select>

                            {referPatientData?.status === "Completed" && (
                              <p className='mt-2 docpro_red_color'><i><strong className='docpro_red_color'>Warning:</strong> If you change status to "complete"! you will not be able to modify this form later.</i></p>
                            )}
                          </div>
                        </div>

                        <Spacing lg="32" sm="32" />
                        <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                          <button
                            type='button'
                            className="docpro_bordered_btn docpro_fw_600 size_lg"
                            onClick={() => handleDrawerClose()}
                          >
                            Cancel
                          </button>
                          <button
                            type='submit'
                            className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                            disabled={updateLoader ? true : false}
                          >
                            <span>Update</span>
                            {updateLoader && (
                              <span className="docpro_loading">
                                <Loader width={20} height={20} />
                              </span>
                            )}
                          </button>              
                        </div>
                      </form>
                    }
                  </div>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}